import { useStyles } from '@webapps/styles';

import { useEditor } from 'context/editor/useEditor';
import { useEffect, useState } from 'react';
import ConventionHeader from '../ConventionHeader';
import ConventionContent from '../ConventionContent';
import { ADD_PAGE } from 'context/editor/editorActions';
import { useToast } from '@webapps/reactjs-tech-components';
import { Button } from '@webapps/reactjs-tech-components';
import { AddRounded } from '@material-ui/icons';

export default function ConventionContainer({ from, selectedDocument, setSelectedDocument, setEditorRef: setEditorRefParent, currentPageIndex, setCurrentPageIndex }) {
  const { classes } = useStyles(styles);

  const { dispatch, state } = useEditor();
  const [editorRef, setEditorRef] = useState(null);
  const [saveContentFunction, setSaveContentFunction] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() => {
    if (editorRef) {
      setEditorRefParent(editorRef);
    }
  }, [editorRef]);

  const { addToast } = useToast();

  const generateId = () => Math.random().toString(36).substring(2, 9);

  const saveCurrentPage = () => {
    setIsSaving(true);

    setTimeout(() => {
      setIsSaving(false);
    }, 500);
  };

  let thisDocumentFormState = {};
  if (from === "dashboard") {
    thisDocumentFormState = selectedDocument;
  } else {
    thisDocumentFormState = state?.documents.find(d => d?.id === selectedDocument?.id);
  }

  const pages = thisDocumentFormState?.pages || [];

  const addNewPage = () => {
    saveCurrentPage();

    const newPage = {
      id: generateId(),
      content: '',
      title: `Page ${pages.length + 1}`
    };

    dispatch({ type: ADD_PAGE, payload: { documentId: selectedDocument?.id, page: newPage } });
    setCurrentPageIndex(pages.length);

    addToast({
      status: 'success',
      message: `Page ${pages.length + 1} créée avec succès.`,
    });
  };

  const handleAddPage = (e) => {
    e.preventDefault();
    addNewPage();
  };


  return (
    <>
      <div className={classes["framerDiv"]}>
        <ConventionHeader
          setSelectedDocument={setSelectedDocument}
          selectedDocument={selectedDocument}
          curentIndex={currentPageIndex}
          editorRef={editorRef}
          currentPageIndex={currentPageIndex}
        />
        <ConventionContent
          currentPageIndex={currentPageIndex}
          setEditorRef={setEditorRef}
          dispatch={dispatch}
          state={state}
          selectedDocument={selectedDocument}
          setCurrentPageIndex={setCurrentPageIndex}
          saveContentFunction={saveContentFunction}
          setSaveContentFunction={setSaveContentFunction}
          from={from}
        />
        {
          from !== "dashboard" && <Button
            className={classes["framerButton5"]}
            onClick={handleAddPage}
          >
            <AddRounded className={classes.framerIcon26} />
            <span style={{ width: "max-content" }}>Ajouter une page </span>
          </Button>
        }
      </div>
      <div className={classes["contentNotAvailable"]}>
        <div className={classes["framerP6"]}>L'éditeur de convention est seulement disponible sur un ordinateur.</div>
      </div>
    </>
  );
}

const styles = ({ spacing, breakpoints }) => ({
  "framerDiv": {
    alignItems: "center",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    flex: "2 0 0",
    height: "min-content",
    justifyContent: "flex-start",
    padding: "24px",
    gap: "24px",

    [breakpoints.down(1255)]: {
      width: "100%",
    },
    [breakpoints.down(1070)]: {
      display: 'none',
    }

  },
  "contentNotAvailable": {
    display: 'flex',
    alignItems: "flex-start",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    height: "min-content",
    justifyContent: "flex-start",
    padding: "20px",
    width: "100%",
    gap: "20px",

    [breakpoints.up(1070)]: {
      display: 'none',
    }
  },

  "framerDiv2": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "space-between",
    width: "100%",
    overflow: "hidden",
  },
  "framerDiv3": {
    alignContent: "center",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    gap: "10px",
    overflow: "hidden",
    placeItems: "center",
  },
  "titleDropdown": {
    borderBottomWidth: "1px",
    borderColor: "#c0d9ff",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderTopWidth: "1px",
    alignItems: "center",
    backgroundColor: "#f3f7ff",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "row",
    height: "30px",
    justifyContent: "space-between",
    padding: "5px 15px",
    width: "160px",
    "&:hover": {
      "& $framerP2": {
        color: "#0060f9",
      },
      "& $framerIcon95": {
        fill: "#0060f9",
      },
      borderColor: "#0060f9",
    },
  },
  "framerP2": {
    fontFamily: "\"Montserrat\", sans-serif",
    fontSize: "13.5px",
    fontWeight: "500",
    lineHeight: "23.625px",
    textAlignment: "center",
    color: "#5d75a8",
  },
  "framerIcon95": {
    height: "24px",
    order: "1",
    width: "24px",
    fill: "#5d75a8",
  },
  "framerButton3": {
    alignContent: "center",
    backgroundColor: "#0060f9",
    borderRadius: "400px",
    display: "flex",
    flexDirection: "column",
    height: "40px",
    padding: "5px 30px",
    gap: "10px",
    placeItems: "center",
    "&:hover": {
      backgroundColor: "#004AC1",
    },
  },
  "framerP3": {
    fontFamily: "\"Montserrat\", sans-serif",
    fontSize: "13.5px",
    fontWeight: "600",
    lineHeight: "23.625px",
    textAlignment: "center",
    color: "#ffffff",
  },
  "framerButton4": {
    borderBottomWidth: "1px ",
    borderColor: "#c0d9ff",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderStyle: "solid",
    borderTopWidth: "1px",
    alignContent: "center",
    alignItems: "center",
    backgroundColor: "#f3f7ff",
    borderRadius: "40px",
    display: "block",
    flexDirection: "row",
    flexWrap: "nowrap",
    height: "40px",
    justifyContent: "space-between",
    padding: "5px 15px",
    width: "240px",
    gap: "8px",
    "&:hover": {
      "& $framerP": {
        lineHeight: "23.625px",
        color: "#0060f9",
      },
      "& $framerIcon26": {
        fill: "#0060f9",
      },
    },
  },
  "framerButton5": {

    border: "1px solid #c0d9ff",
    alignContent: "center",
    alignItems: "center",
    backgroundColor: "#f3f7ff",
    borderRadius: "40px",
    display: "block",
    flexDirection: "row",
    flexWrap: "nowrap",
    height: "40px",
    justifyContent: "space-between",
    padding: "5px 15px",
    width: "min-content",
    gap: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "span": {
      gap: "8px",
    },
    "&:hover": {
      borderColor: "#0060f9",
      "span": {
        color: "#0060f9",
      },
      "svg": {
        fill: "#0060f9",
      },
    },
  },
});